// @ts-nocheck
import { Global } from "@emotion/react";
import { variant } from "./fontVariant";

// @ts-nocheck
export const Fonts = () => <Global styles={variant} />;
